module.exports = __webpack_public_path__ + "img/cg.c11f260b.png";